@let isLoginButton = layout() === layouts.PUBLIC || !userProfile();

@if (isLoginButton) {
  <evc-user-badge
    data-testid="login"
    (click)="onLogin()"
    class="user-badge"
    [isIms]="isIms()"
    [layout]="layout()"
    [host]="host()" />
} @else {
  <evc-menu
    [position]="menuPosition()"
    [isOpen]="onlyMenu() || undefined"
    data-testid="user-menu">
    @if (!onlyMenu()) {
      <evc-user-badge
        trigger
        evcMenuTriggerState
        class="trigger user-badge"
        [isIms]="isIms()"
        [layout]="layout()"
        [host]="host()" />
    }
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </evc-menu>
}

<ng-template #contentTemplate>
  @let profile = userProfile()!;
  <header>
    <section class="general-info">
      <p class="title">
        {{ greetings() }}, <span class="username">{{ profile.displayName }}</span>
      </p>
      <p class="email">{{ profile.email }}</p>
    </section>
    <section class="user-actions">
      <div class="divider-box">
        <div class="divider-bar"></div>
      </div>
      <evc-menu-item
        data-testid="user-menu__account-link"
        [badgeItem]="menuItems().userAccount"
        [externalContext]="true"
        (click)="redirectUserProfile()"></evc-menu-item>
    </section>
    <div class="divider-box">
      <div class="divider-bar"></div>
    </div>
  </header>

  @if (showOrganizations()) {
    <section class="organizations">
      <p class="subtitle">{{ ('menus.user.organizations.title' | platformTranslate)() }}</p>
      <div
        class="organization-list"
        data-testid="user-menu__organizations-list"
        [attr.data-scrollable]="organizations().length > MAX_ORGANIZATIONS_BEFORE_SCROLL">
        @for (organization of organizations(); track organization.id) {
          <evc-menu-item
            class="item"
            [attr.data-id]="organization.id"
            [selected]="!!organization.current"
            [badgeItem]="organization"
            [aditionalText]="organization.additionalText"
            (click)="onChangeOrganization(organization.id)"></evc-menu-item>
        }
        <evc-menu-item
          data-testid="user-menu__add-organization"
          [badgeItem]="menuItems().addOrganization"
          (click)="addOrganization()"></evc-menu-item>
      </div>
    </section>
    <footer>
      <div class="divider-box">
        <div class="divider-bar"></div>
      </div>
      <evc-menu-item
        data-testid="logout"
        [badgeItem]="menuItems().logout"
        (click)="onLogout()"></evc-menu-item>
    </footer>
  }
</ng-template>
